import { render } from "./ReminderServiceResultListItem.vue?vue&type=template&id=c9f00858"
import script from "./ReminderServiceResultListItem.vue?vue&type=script&lang=js"
export * from "./ReminderServiceResultListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__